const roiGateFormDataStore = require("./roiGateFormDataStore");

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {void}
 */
module.exports = function saveRoiGateFormData(roiGateFormData) {
    roiGateFormDataStore.data = roiGateFormData;
}
